<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {fly} from 'svelte/transition';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import InfoBanner from 'shared/ui-widgets/banner/InfoBanner.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let loading = true;
    export let loadError = false;
    export let withoutAnimations = false;
    export let fillSize = false;

    const flyInAnimParams = {y: 10, duration: withoutAnimations ? 0 : 375};
    const dispatch = createEventDispatcher<{'retry': void}>();
</script>

{#if loading}
    <KpLoadingBlock fillPage={fillSize}/>
{/if}

{#if loadError}
    <div in:fly={flyInAnimParams}>
        <InfoBanner bannerType="error">
            <svelte:fragment slot="text">
                Nastala chyba při načítání dat!
            </svelte:fragment>

            <KpButton on:click={() => dispatch('retry')}>
                <IconedContent icon="refresh">Zkusit znovu</IconedContent>
            </KpButton>
        </InfoBanner>
    </div>
{/if}

{#if !loading && !loadError}
    <div class:fill-size={fillSize} in:fly={flyInAnimParams}>
        <slot/>
    </div>
{/if}

<style lang="less">
    @import (reference) "styles/portaro-erp.less";

    .fill-size {
        position: relative;
        .flex-grow();
    }
</style>